module.exports = "https://static.wmbcdn.com/uniweb/images/24327171092f79feab226b7defb72b69.svg";